import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/dropdown_arrow.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3b0bcaac")

_pushScopeId("data-v-3b0bcaac")
const _hoisted_1 = { class: "search-dropdown-list" }
const _hoisted_2 = { class: "dropdown" }
const _hoisted_3 = {
  class: "dropdown-button dropdown-toggle dropdown-toggle-split",
  type: "button",
  id: "dropdownMenuButton",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_4 = { class: "dropdown_text_area" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "dropdown_icon",
  src: _imports_0
}, null, -1)
const _hoisted_6 = {
  class: "dropdown-menu",
  "aria-labelledby": "dropdownMenuButton"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SearchDropdownButtonItem = _resolveComponent("SearchDropdownButtonItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.getSelectLabel()) + " ", 1 /* TEXT */),
          _hoisted_5
        ])
      ]),
      _createVNode("ul", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dropdownList, (item) => {
          return (_openBlock(), _createBlock(_component_SearchDropdownButtonItem, {
            key: item.id,
            label: item.label,
            onSelectItem: _ctx.selectItem
          }, null, 8, ["label", "onSelectItem"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})